import Icon from '@/components/common/iconedLinks/Icon';
import { URLS } from '@/constants/urls';
import React, { FC } from 'react';

import styles from './Toggle.module.scss';

type IconProps = {
  src: string;
  width: number;
  height: number;
  alt: string;
  onClick?: () => void;
}

type Props = {
  iconLeft: IconProps;
  iconRight: IconProps;
}

export const Toggle: FC<Props> = ({ iconLeft, iconRight }) => {
  return (
    <div className={styles.icons}>
      <Icon {...iconLeft} className={styles['icon-left']} />
      <Icon {...iconRight} className={styles['icon-right']} />
    </div>
  );
};
